import { formatCompletedTime } from "../../intelligence/intelligenceLabels";
import SourceHealthBadge from "../SourceHealthBadge";

function formatDuration(startedAt, finishedAt) {
  if (!startedAt || !finishedAt) {
    return "—";
  }
  const startMs = new Date(startedAt).getTime();
  const endMs = new Date(finishedAt).getTime();
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) {
    return "—";
  }
  const seconds = Math.max(0, Math.round((endMs - startMs) / 1000));
  if (seconds < 60) {
    return `${seconds}s`;
  }
  return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
}

const CultureSourceRunHistory = ({
  source,
  runs = [],
  isOpen,
  isLoading,
  errorMessage,
  onClose,
  onRefresh,
}) => {
  if (!isOpen || !source) {
    return null;
  }

  return (
    <div className="admin-re-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="admin-re-modal panel-card admin-re-modal--wide"
        role="dialog"
        aria-labelledby="culture-runs-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="admin-re-modal-header">
          <div>
            <p className="eyebrow">Culture ingestion runs</p>
            <h2 id="culture-runs-modal-title">{source.sourceName}</h2>
            <p className="muted admin-re-source-code">{source.sourceKey || source.sourceCode}</p>
          </div>
          <div className="admin-re-modal-header__actions">
            <button type="button" className="midpoint-share-button" onClick={onRefresh}>
              Refresh
            </button>
            <button type="button" className="midpoint-share-button" onClick={onClose}>
              Close
            </button>
          </div>
        </header>

        <div className="admin-re-modal-body">
          {isLoading ? <p className="muted">Loading run history…</p> : null}
          {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}

          {!isLoading && !errorMessage && !runs.length ? (
            <p className="muted">No ingestion runs recorded yet.</p>
          ) : null}

          {!isLoading && runs.length ? (
            <div className="admin-data-health-table-wrap">
              <table className="admin-data-health-table admin-re-runs-table">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Mode</th>
                    <th>Started</th>
                    <th>Finished</th>
                    <th>Duration</th>
                    <th>Found</th>
                    <th>Inserted</th>
                    <th>Updated</th>
                    <th>Skipped</th>
                    <th>Metrics</th>
                    <th>Error</th>
                  </tr>
                </thead>
                <tbody>
                  {runs.map((run) => (
                    <tr key={run.runId || `${run.startedAt}-${run.status}`}>
                      <td>
                        <SourceHealthBadge status={String(run.status || "unknown").toLowerCase()} />
                      </td>
                      <td>{run.mode || run.metadata?.dryRunMode ? "dry_run" : run.metadata?.applyMode ? "apply" : "—"}</td>
                      <td>{formatCompletedTime(run.startedAt)}</td>
                      <td>{formatCompletedTime(run.finishedAt)}</td>
                      <td>{formatDuration(run.startedAt, run.finishedAt)}</td>
                      <td>{run.recordsFound ?? 0}</td>
                      <td>{run.recordsInserted ?? 0}</td>
                      <td>{run.recordsUpdated ?? 0}</td>
                      <td>{run.recordsSkipped ?? 0}</td>
                      <td className="muted admin-re-runs-table__metrics">
                        {run.metrics?.venueMatchRate != null
                          ? `${Math.round(run.metrics.venueMatchRate * 100)}% venues`
                          : "—"}
                        {run.metrics?.tagCoverageRate != null
                          ? ` · ${Math.round(run.metrics.tagCoverageRate * 100)}% tags`
                          : ""}
                        {run.metrics?.parserDriftStatus
                          ? ` · drift ${run.metrics.parserDriftStatus}`
                          : ""}
                      </td>
                      <td className="admin-re-runs-table__error">
                        {run.errorMessage ? run.errorMessage : "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CultureSourceRunHistory;
